import { Controller } from "stimulus";

export default class extends Controller {

  switchLocale(e) {
    window.location.href = e.target.value;
  }
}
